// extracted by mini-css-extract-plugin
export default {"tag":"TagLabel_tag__vvX18"};